<app-header></app-header>

<ion-content
  *ngIf="(product$ | async) as product"
  data-cy="product-detail-content"
  class="product-detail-content"
>
  <ion-grid [fixed]="true" class="product-detail-grid">
    <ng-container *ngIf="product && !product.notFound">
      <section class="product-detail-section">
        <app-product-detail-toast
          *ngIf="!!toast"
          [toast]="toast"
        ></app-product-detail-toast>
        <app-product-detail-summary
          [product]="product"
          [sellerPriceDetail]="sellerPriceDetails$ | async"
          [divisionalPromotions]="divisionalPromotions$ | async"
          [orderItem]="orderItem$ | async"
          [isInventory]="false"
          [pricingDisabled]="product.selectedCustomer?.ogPrintPriceInd === 'N'"
          [isGuestUser]="isGuestUser$ | async"
          [newSearchEnabled]="newSearchEnabled$ | async"
          (tabSelectionEmitter)="onTabSelection($event)"
          (quantityUpdateEmitter)="onQuantityUpdate($event)"
          (shareButtonPressEmitter)="onShareButtonPress()"
          (printButtonPressEmitter)="onPrintButtonPress()"
        ></app-product-detail-summary>
        <section
          *ngIf="product.hasAlternative && product.alternative && !isSellerCustomer && (isGuestUser$ | async) === false"
          class="product-alt-section"
        >
          <app-product-alternative
            *ngIf="product.alternative.required && product.alternative.available"
            [productAlternative]="product.alternative"
            [originalProduct]="product"
            [selectedProductNumber]="selectedProductNumber"
            [orderItem]="alternativeOrderItem$ | async"
            [isGuestUser]="isGuestUser$ | async"
            [pricingDisabled]="product.selectedCustomer?.ogPrintPriceInd === 'N'"
            (quantityUpdateEmitter)="onQuantityUpdate($event)"
          ></app-product-alternative>
        </section>
        <ng-container
          *ngIf="
            product.betterBuy &&
            !(product.alternative && product.alternative.required && product.alternative.available) &&
            !isSellerCustomer
          "
        >
          <div class="title-section">
            {{ product.betterBuy.reason | translate }}
          </div>
          <ng-container *ngIf="betterBuyProduct$ | async as betterBuyProduct">
            <app-better-buys-conversion-product-card
              *ngIf="platformService.platformType === PlatformEnum.desktop"
              [product]="betterBuyProduct"
              [platform]="platformService.platformType"
              [samePackSize]="
                product?.summary?.salesPackSize ===
                product?.betterBuy?.product?.summary?.salesPackSize
              "
              [savings]="product.betterBuy.savings"
              [savingsUom]="product.betterBuy.savingsUom"
              [annualSavings]="product.betterBuy.annualSavings"
              [annualSavingsUom]="product.betterBuy.annualSavingsUom"
              [savingsPerCase]="product.betterBuy.savingsPerCase"
              [isOnline]="(panAppState.online$ | async)"
              [pricingDisabled]="product.selectedCustomer?.ogPrintPriceInd === 'N'"
              (changeQuantityEmitter)="changeBetterBuysQuantityHandler($event)"
              (acceptSwapEmitter)="acceptSwap()"
              (productImageClickEmitter)="handleProductImageClick($event, betterBuyProduct)"
            ></app-better-buys-conversion-product-card>
            <app-better-buys-conversion-product-card-tablet
              *ngIf="platformService.platformType === PlatformEnum.tablet"
              [product]="betterBuyProduct"
              [platform]="platformService.platformType"
              [samePackSize]="
                product?.summary?.salesPackSize ===
                product?.betterBuy?.product?.summary?.salesPackSize
              "
              [savings]="product.betterBuy.savings"
              [savingsUom]="product.betterBuy.savingsUom"
              [annualSavings]="product.betterBuy.annualSavings"
              [annualSavingsUom]="product.betterBuy.annualSavingsUom"
              [savingsPerCase]="product.betterBuy.savingsPerCase"
              [isOnline]="(panAppState.online$ | async)"
              [pricingDisabled]="product.selectedCustomer?.ogPrintPriceInd === 'N'"
              (changeQuantityEmitter)="changeBetterBuysQuantityHandler($event)"
              (acceptSwapEmitter)="acceptSwap()"
              (productImageClickEmitter)="handleProductImageClick($event, betterBuyProduct)"
            ></app-better-buys-conversion-product-card-tablet>
            <app-better-buys-conversion-product-card-mobile
              *ngIf="platformService.platformType === PlatformEnum.mobile"
              [product]="betterBuyProduct"
              [platform]="platformService.platformType"
              [samePackSize]="
                product?.summary?.salesPackSize ===
                product?.betterBuy?.product?.summary?.salesPackSize
              "
              [savings]="product.betterBuy.savings"
              [savingsUom]="product.betterBuy.savingsUom"
              [annualSavings]="product.betterBuy.annualSavings"
              [annualSavingsUom]="product.betterBuy.annualSavingsUom"
              [savingsPerCase]="product.betterBuy.savingsPerCase"
              [isOnline]="(panAppState.online$ | async)"
              [pricingDisabled]="product.selectedCustomer?.ogPrintPriceInd === 'N'"
              (changeQuantityEmitter)="changeBetterBuysQuantityHandler($event)"
              (acceptSwapEmitter)="acceptSwap()"
              (productImageClickEmitter)="handleProductImageClick($event, betterBuyProduct)"
            ></app-better-buys-conversion-product-card-mobile>
          </ng-container>
        </ng-container>
        <ng-container *ngIf="isSellerCustomer">
          <app-seller-detail-description
            [sellerPriceDetail]="sellerPriceDetails$ | async"
            [product]="product"
          ></app-seller-detail-description>
          <app-seller-detail-more-information
            *ngIf="(isSuperUser$ | async) === false"
            [product]="product"
            [sellerPriceDetails]="sellerPriceDetails$ | async"
            [currentProductNumber]="selectedProductNumber"
            [isDynamicLastFourBuysLookbackEnabled]="isDynamicLastFourBuysLookbackEnabled$ | async"
          ></app-seller-detail-more-information>
        </ng-container>
        <ng-container *ngIf="!isSellerCustomer">
          <app-product-detail-related-products
            [product]="product"
            [currentProductNumber]="selectedProductNumber"
            [isGuestUser]="isGuestUser$ | async"
            (productImageClickEmitter)="trackProductImageClick($event)"
          ></app-product-detail-related-products>
          <app-product-detail-description
            [product]="product"
          ></app-product-detail-description>
        </ng-container>
      </section>
      <section class="product-detail-section">
        <ng-container *ngIf="!isSellerCustomer">
          <app-product-detail-additional-info
            [product]="product"
            [isUsdaNutritionFlagOn]="isUsdaNutritionFlagOn$ | async"
          ></app-product-detail-additional-info>
          <app-product-detail-shipping-info
            [product]="product"
          ></app-product-detail-shipping-info>
        </ng-container>
        <app-seller-detail-carousel-videos
          [product]="product.summary"
          *ngIf="isSellerCustomer"
        >
        </app-seller-detail-carousel-videos>
        <app-product-detail-downloads
          *ngIf="product.summary?.productAssets?.documents && !isSellerCustomer"
          [rawDocuments]="product.summary?.productAssets?.documents"
        ></app-product-detail-downloads>
      </section>
      <section
        class="report-discrepancies"
        *ngIf="product?.isNonFood && !isSellerCustomer"
      >
        <app-product-detail-report-discrepancies>
        </app-product-detail-report-discrepancies>
      </section>
      <ng-container *appShowSplit="[questionsAndAnswersFeatureFlag]">
        <section
          *ngIf="!isSellerCustomer && product.summary?.isExclusiveBrand"
          class="product-detail-question-section"
        >
          <app-pwr-product-details-questions
            [productNumber]="selectedProductNumber"
            [emptyState]="noQuestions"
            [isGuestUser]="isGuestUser$ | async"
          ></app-pwr-product-details-questions>
        </section>
      </ng-container>
      <ng-container *appShowSplit="[productReviewsFeatureFlag]">
        <section *ngIf="!isSellerCustomer" class="product-detail-section">
          <app-power-reviews-details
            [productNumber]="selectedProductNumber"
            [isGuestUser]="isGuestUser$ | async"
          ></app-power-reviews-details>
        </section>
      </ng-container>
    </ng-container>
  </ion-grid>
  <ion-grid
    *ngIf="product?.notFound"
    [fixed]="true"
    class="product-detail-grid"
  >
    <app-product-detail-not-found></app-product-detail-not-found>
  </ion-grid>
  <app-footer></app-footer>
</ion-content>
<div class="go-top-section">
  <ion-button
    class="usf-fill-green-button"
    data-cy="go-to-top-button"
    (click)="goToTop()"
  >
    {{ 'i18n.common.top' | translate }}
    <ion-icon
      name="chevron-up-circle-outline"
      data-cy="go-to-top-button-icon"
    ></ion-icon>
  </ion-button>
</div>

<div class="help-icon">
  <img
    data-cy="pdp-page-open-help-modal-button"
    src="assets/icon/custom-help-tooltip.svg"
    (click)="openHelpModal()"
  />
</div>
